import { connect } from 'react-redux'

import * as questionnaireAdminActions from '../../ducks/questionnaire-admin'
import * as groupDriversActions from '../../ducks/group-drivers'
import GroupDriversComparison from '../GroupDriversComparison'

function mapStateToProps(state) {
  return {
    currentLanguage: state.account.get('currentLanguage'),
    questionnaireUuid: state.questionnaireAdmin.get('questionnaireUuid'),
    questionnaires: state.questionnaireAdmin.get('questionnaires'),
    deletedInvitations: state.questionnaireAdmin.get('deletedInvitations'),
    searchFilters: state.questionnaireAdmin.get('searchFilters'),
    pagination: state.questionnaireAdmin.get('pagination'),
    sentInvitations: state.questionnaireAdmin.get('sentInvitations'),
    showOnlyOwnQuestionnaires: state.questionnaireAdmin.get('showOnlyOwnQuestionnaires'),
    token: window.localStorage.getItem('token'),
    groupDriversProfiles: state.groupDrivers.get('groupDriversProfiles')
  }
}

export default connect(mapStateToProps, {
  onSearch: questionnaireAdminActions.search,
  onDeleteInvitation: questionnaireAdminActions.deleteInvitation,
  onShowOnlyOwnQuestionnaires: questionnaireAdminActions.setShowOnlyOwnQuestionnaires,
  onGetGroupDriversProfiles: groupDriversActions.groupDriversProfiles
})(GroupDriversComparison)



// WEBPACK FOOTER //
// ./src/components/smart/GroupDriversComparisonContainer.js